const cpf = () => [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
const cnpj = () => {
  const alfanumerico = /[A-Za-z0-9]/
  return [alfanumerico, alfanumerico, '.', alfanumerico, alfanumerico, alfanumerico, '.', alfanumerico, alfanumerico, alfanumerico, '/', alfanumerico, alfanumerico, alfanumerico, alfanumerico, '-', /\d/, /\d/]
}

const data = () => [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]

const telefone = () => ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

const celular = () => ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

const cep = () => [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]

const titulo = () => [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]

export {
  cpf,
  cnpj,
  cep,
  data,
  telefone,
  celular,
  titulo,
}
